(function (doc, win) {
  let docEl = doc.documentElement

  let resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize'
  let recalc = function () {
    let clientWidth = docEl.clientWidth
    if (!clientWidth) return
    if(clientWidth<=1200){
      clientWidth=1200;
    }
      docEl.style.fontSize =50 * (clientWidth / 1920) + 'px';
  }
  if (!doc.addEventListener) return
  win.addEventListener(resizeEvt, recalc, false)
  doc.addEventListener('DOMContentLoaded', recalc, false)
})(document, window)
